// extracted by mini-css-extract-plugin
module.exports = {"postPageTagContainer":"NtKSQ","tagLabel":"_10Ab9","navigation":"Ev29Q"};